import React, { Component } from 'react'
import { func, array, node, number, bool } from 'prop-types'
import Fade from './fade'

class Paginator extends Component {
  constructor (props) {
    super(props)
    this.state = {
      page: 0
    }
    this.scrollRef = null

    this.getTotalPageCount = this.getTotalPageCount.bind(this)
    this.grabScrollRef = this.grabScrollRef.bind(this)
    this.renderControls = this.renderControls.bind(this)
    this.setPage = this.setPage.bind(this)
  }

  grabScrollRef (ref) {
    this.scrollRef = ref
  }

  setPage (pageNum) {
    this.setState({ page: pageNum }, () => {
      window &&
        this.scrollRef &&
        window.scrollTo(0, this.scrollRef.offsetParent.offsetTop)
    })
  }

  renderControls () {
    const { page } = this.state
    const pageCount = this.getTotalPageCount()
    const isLastPage = page === pageCount - 1
    const isFirstPage = page === 0

    return (
      <ul className='pagination'>
        <li className={isFirstPage ? 'disabled' : ''} key='first'>
          <a onClick={() => (!isFirstPage ? this.setPage(page - 1) : null)}>
            «
          </a>
        </li>

        {new Array(pageCount).fill(null).map((_, key) => (
          <li className={key === page ? 'active' : ''} key={key}>
            <a onClick={() => this.setPage(key)}>{key + 1}</a>
          </li>
        ))}

        <li className={isLastPage ? 'disabled' : ''} key='last'>
          <a onClick={() => (!isLastPage ? this.setPage(page + 1) : null)}>»</a>
        </li>
      </ul>
    )
  }

  getTotalPageCount () {
    const { items = [], perPage } = this.props
    return Math.ceil(items.length / perPage)
  }

  render () {
    const { page } = this.state
    const {
      items = [],
      itemRender: ItemComponent = () => {},
      children,
      showTopControls = true,
      showBottomControls = true,
      perPage
    } = this.props

    const pageCount = this.getTotalPageCount()
    const showFrom = page * perPage
    const showTo = Math.min(showFrom + perPage, items.length)
    const itemsToShow = items.slice(showFrom, showTo)

    return (
      <div ref={this.grabScrollRef}>
        {showTopControls && pageCount > 1 && this.renderControls()}
        {pageCount > 1 && (
          <div className='pagination-description'>
            Zeige {showFrom + 1} - {showTo}
          </div>
        )}
        {children}
        <Fade>
          {itemsToShow.map((item, index) => (
            <ItemComponent item={item} key={index} />
          ))}
        </Fade>
        {showBottomControls && pageCount > 1 && this.renderControls()}
      </div>
    )
  }
}

Paginator.propTypes = {
  items: array.isRequired,
  itemRender: func.isRequired,
  children: node,
  perPage: number,
  showTopControls: bool,
  showBottomControls: bool
}

export default Paginator



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/de/paginator.jsx